export const MAPPING_KEYS = {
  ['VERY GOOD']: 'VERY GOOD',
  ['NEED ATTENTION']: 'NEED ATTENTION',
  ['VERY POOR']: 'VERY POOR',
  ['NO DATA']: 'NO DATA',
  VERY_POOR: 'VERY_POOR',
  POOR: 'POOR',
  AVERAGE: 'AVERAGE',
  GOOD: 'GOOD',
  VERY_GOOD: 'VERY_GOOD',
  SUFFICIENT: 'SUFFICIENT',
  NEED_ATTENTION: 'NEED_ATTENTION',
  NO_DATA: 'NO_DATA',
};
